import {isNullOrUndefined} from "../services/Validator";

// METHODS
// ---- Make user text its latex version
export function latexifyString(userText) {
    // Defense
    if (isNullOrUndefined(userText)) return "\\(\\)"; // cas vide

    // Perform
    const safeText = userText.replace(/,/g, "{,}");

    // Return
    return `\\( ${safeText} \\)`;
}

